function getPlatform(): "Android" | "iOS" | "Windows" | "macOS" | undefined {
  if (typeof navigator === "undefined") return undefined;

  if (navigator.userAgentData && navigator.userAgentData.platform) {
    if (navigator.userAgentData.platform === "Linux") return "Android";
    return navigator.userAgentData.platform as "Android" | "Windows" | "macOS";
  }
  if (/^Android|^Linux/.test(navigator.platform)) return "Android";
  if (/^iPad|^iPhone|^iPod/.test(navigator.platform)) return "iOS";
  if (/^Win/.test(navigator.platform)) return "Windows";
  if (/^Mac/.test(navigator.platform)) return CSS.supports("-webkit-touch-callout", "none") ? "iOS" : "macOS";
  return undefined;
}

export const platform = getPlatform();

/**
 * @deprecated ブラウザの設定や偽装によって正確性に影響を受ける、
 * またプライバシー保護のため将来userAgentが削除される可能性があるため非推奨
 *
 * Safariではbfcacheを使用してページを表示する場合、変数など全てがcacheされているため
 * useEffect内の依存関数が更新されず、バグの発生理由になるのでやむをえず、使用する
 */
export const isSafari = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1 && userAgent.indexOf("edg") === -1;
};
